import { cn } from "@newxsystems/shared";
import type { IDaylightRichTextProps } from "./DaylightRichText.props";

export const DaylightRichText = ({ className, content }: IDaylightRichTextProps) => (
  <div
    className={cn(
      "leading-[1.55] text-pretty [&_a]:text-primary [&_a]:underline [&_a]:underline-offset-4 [&_a:hover]:text-graphite [&_blockquote]:border-l [&_blockquote]:border-border [&_blockquote]:pl-6 [&_blockquote]:text-northsea [&_li]:my-2 [&_ol]:list-decimal [&_ol]:pl-6 [&_strong]:font-medium [&_strong]:text-graphite [&_ul]:list-disc [&_ul]:pl-6 [&_p+p]:mt-5",
      className,
    )}
    dangerouslySetInnerHTML={{ __html: content }}
  />
);

DaylightRichText.displayName = "Content::DaylightRichText";
